import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { logoutUser } from "../utils/Storage";
import { toggleMenu } from "../utils/helpers";
import NotificationBadge from "./NotificationBadge";
import Cookies from "js-cookie";
import { getApi } from "../utils/api";
import { API_GET_PENDING_LEAVE_REQUESTS } from "../config/Endpoints";
import { useEvent } from "../Hooks/useEvent";
import { Event } from "../config/events";

const NotifyDot = ({ animation = true }) => {
  return (
    <div className="position-relative">
      <span
        className={`notifyDot ${animation ? "notificationAnimation" : ""}`}
      ></span>
    </div>
  );
};

export default function SideNavbar({ menu }) {
  const [menuList, setMenuList] = useState([]);
  const { pathname } = useLocation();
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [subMenu, setSubMenu] = useState(null);
  const [leaveData, setLeaveData] = useState([]);
  const accessToken = Cookies.get("accessToken");

  const preprocessMenuList = () => {
    const subItems = [
      { name: "Attendance Report", achorValue: "/exportAttendance" },
      { name: "Reimbursement Report", achorValue: "/downloadReimbursement" },
    ];

    const processedMenu = menu.map((item) => {
      const newItem = { ...item };
      if (item.name === "Analytics & Insights" && Array.isArray(item.subMenu)) {
        newItem.subMenu = [...item.subMenu];
        subItems.forEach((subItem) => {
          if (
            !newItem.subMenu.some(
              (existing) => existing.achorValue === subItem.achorValue
            )
          ) {
            newItem.subMenu.push(subItem);
          }
        });
      }
      return newItem;
    });

    return processedMenu;
  };

  const mergeLeaveData = (processedMenu) => {
    return processedMenu.map((item) => {
      let hasNotification = false;
      const updatedSubMenu =
        item.subMenu?.map((sub) => {
          const found = leaveData.find(
            (ld) => ld.childName === sub.name && ld.parentName === item.name
          );
          if (found && found.count > 0) {
            hasNotification = true;
            return { ...sub, notificationValue: found.count };
          }
          return sub;
        }) || [];

      return { ...item, subMenu: updatedSubMenu, hasNotification };
    });
  };
  const fetchLeaveData = () => {
    getApi(API_GET_PENDING_LEAVE_REQUESTS, accessToken)
      .then((response) => {
        setLeaveData(response.data.data);
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    fetchLeaveData();
  }, []);

  const handleLeaveUpdate = () => {
    fetchLeaveData();
  };

  useEvent(Event.SIDEBAR.NOTIFY_EVENT, handleLeaveUpdate);

  useEffect(() => {
    if (menu && menu.length > 0) {
      const processedMenu = preprocessMenuList();

      // Move "Project Management" to the 3rd position (index 2)
      const projectIndex = processedMenu.findIndex(
        (item) => item.name === "Project TeamFlow"
      );
      if (projectIndex !== -1 && projectIndex !== 2) {
        const [projectItem] = processedMenu.splice(projectIndex, 1);
        processedMenu.splice(3, 0, projectItem);
      }
      //Move "Off boarding" to one step above
      const offboardingIndex = processedMenu.findIndex(
        (item) => item.name === "Employee Offboarding"
      );
      if (offboardingIndex > 0) {
        const [offboardingItem] = processedMenu.splice(offboardingIndex, 1);
        processedMenu.splice(offboardingIndex - 1, 0, offboardingItem);
      }

      const finalMenu = mergeLeaveData(processedMenu);
      setMenuList(finalMenu);
    }
  }, [menu, leaveData]);
  // useEffect(() => {
  //   if (menu && menu.length > 0) {
  //     const processedMenu = preprocessMenuList();
  //     const finalMenu = mergeLeaveData(processedMenu);

  //     setMenuList(finalMenu);
  //   }
  // }, [menu, leaveData]);

  const handleSubMenuClick = (index) => {
    if (activeSubMenu === index) {
      setActiveSubMenu(null);
      setSubMenu(null);
    } else {
      setActiveSubMenu(index);
      setSubMenu(null);
    }
  };

  const handleSubMenuActiveClick = (index) => {
    if (subMenu === index) {
      setSubMenu(null);
    } else {
      setSubMenu(index);
    }
  };

  return (
    <nav className="custom-scrollbar">
      <div id="hideMenuBtn" className="close-button" onClick={toggleMenu}>
        <span></span>
        <span></span>
      </div>
      <a href="/dashboard/" className="text-center">
        <img
          src="/assets/caelius-logo.svg"
          alt="Caelius Consulting Logo"
          width="135"
          height="32"
        />
      </a>
      <ul className="mt-5">
        {menuList?.map((item, index) => {
          const mainMenuPath =
            item.subMenu && item.subMenu.length > 0
              ? null
              : `/dashboard${item.achorValue}`;
          const isActiveMainMenu = pathname === mainMenuPath;
          const isSubMenuOpen =
            item.subMenu &&
            item.subMenu.length > 0 &&
            pathname.includes(item.subMenu[0].achorValue);

          return (
            <li
              key={index}
              className={`${activeSubMenu === index ? "active" : ""}`}
            >
              {item.subMenu && item.subMenu.length > 0 ? (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubMenuClick(index);
                  }}
                  aria-expanded={activeSubMenu === index}
                >
                  {item.name}
                  {item.hasNotification ? <NotifyDot animation={true} /> : ""}

                  <span className="ms-auto">
                    <i
                      className={`fa ${
                        activeSubMenu === index
                          ? "fa-angle-down"
                          : "fa-angle-right"
                      }`}
                    />
                  </span>
                </a>
              ) : (
                /* For items without submenus, use Link for navigation */
                <Link
                  to={mainMenuPath}
                  className={isActiveMainMenu ? "active" : ""}
                >
                  {item.name}
                </Link>
              )}

              {item?.subMenu?.length > 0 && (
                <ul
                  className={`submenu ${activeSubMenu === index ? "show" : ""}`}
                >
                  {item.subMenu.map((menu, subIndex) => {
                    const subMenuPath = `/dashboard${menu.achorValue}`;
                    const isActiveSubMenu = pathname === subMenuPath;

                    return (
                      <li
                        key={subIndex}
                        className={`submenu ${
                          isActiveSubMenu ? "active " : ""
                        }`}
                      >
                        <Link
                          to={subMenuPath}
                          onClick={() => handleSubMenuActiveClick(subIndex)}
                        >
                          {menu.name}
                          {menu.notificationValue &&
                          menu.notificationValue > 0 ? (
                            <NotificationBadge count={menu.notificationValue} />
                          ) : null}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
      {/* Log Out */}
      <div className="log-out">
        <a onClick={logoutUser} className="text-center">
          <img
            src="/assets/images/logout.svg"
            alt="Logout"
            width="25"
            height="25"
          />
          Log Out
        </a>
      </div>
    </nav>
  );
}
